import { errors } from 'rfc9457';

import { readEnvVariable } from '../helpers';

export interface IBetterAuthEnv {
  secret: string;
  googleClientId: string;
  googleClientSecret: string;
  appleAuthPrivateKey: string | undefined;
}

export function getBetterAuthEnv(): IBetterAuthEnv {
  const secret = readEnvVariable('BETTER_AUTH_SECRET');
  const googleClientId = readEnvVariable('GOOGLE_CLIENT_ID');
  const googleClientSecret = readEnvVariable('GOOGLE_CLIENT_SECRET');
  const appleAuthPrivateKey = readEnvVariable('APPLE_AUTH_PRIVATE_KEY') || undefined;

  if (!secret) {
    throw errors.server.envNotSet('BETTER_AUTH_SECRET');
  }

  if (!googleClientId) {
    throw errors.server.envNotSet('GOOGLE_CLIENT_ID');
  }

  if (!googleClientSecret) {
    throw errors.server.envNotSet('GOOGLE_CLIENT_SECRET');
  }

  return {
    secret,
    googleClientId,
    googleClientSecret,
    appleAuthPrivateKey,
  };
}
